module.exports = __webpack_public_path__ + "8381168f62abb0afc4b96b48d6c3fdd6.jpg";